"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _lodash = require("lodash");
var _polished = require("polished");
var _styledComponents = require("styled-components");
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _constants = require("./constants");
var _helpers = require("./helpers");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function cov_3e0awlrzq() {
  var path = "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/buttonEvolutionStyles.js";
  var hash = "02c2e31ad4cbaf914c1a801e9b5d6008eab6f59c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/buttonEvolutionStyles.js",
    statementMap: {
      "0": {
        start: {
          line: 17,
          column: 32
        },
        end: {
          line: 17,
          column: 48
        }
      },
      "1": {
        start: {
          line: 19,
          column: 30
        },
        end: {
          line: 126,
          column: 1
        }
      },
      "2": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 98
        }
      },
      "3": {
        start: {
          line: 42,
          column: 32
        },
        end: {
          line: 42,
          column: 81
        }
      },
      "4": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 66,
          column: 5
        }
      },
      "5": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 73,
          column: 5
        }
      },
      "6": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 88,
          column: 5
        }
      },
      "7": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 105,
          column: 5
        }
      },
      "8": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 118,
          column: 5
        }
      },
      "9": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 125,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        },
        loc: {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 98
          }
        },
        line: 28
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 42,
            column: 22
          },
          end: {
            line: 42,
            column: 23
          }
        },
        loc: {
          start: {
            line: 42,
            column: 32
          },
          end: {
            line: 42,
            column: 81
          }
        },
        line: 42
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        loc: {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 66,
            column: 5
          }
        },
        line: 53
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        },
        loc: {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 73,
            column: 5
          }
        },
        line: 69
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        },
        loc: {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 88,
            column: 5
          }
        },
        line: 85
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 5
          }
        },
        loc: {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        },
        line: 91
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 107,
            column: 5
          }
        },
        loc: {
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        },
        line: 108
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 120,
            column: 4
          },
          end: {
            line: 120,
            column: 5
          }
        },
        loc: {
          start: {
            line: 121,
            column: 4
          },
          end: {
            line: 125,
            column: 5
          }
        },
        line: 121
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 21
          }
        }, {
          start: {
            line: 28,
            column: 25
          },
          end: {
            line: 28,
            column: 98
          }
        }],
        line: 28
      },
      "1": {
        loc: {
          start: {
            line: 42,
            column: 32
          },
          end: {
            line: 42,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 42,
            column: 48
          },
          end: {
            line: 42,
            column: 61
          }
        }, {
          start: {
            line: 42,
            column: 64
          },
          end: {
            line: 42,
            column: 81
          }
        }],
        line: 42
      },
      "2": {
        loc: {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 66,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 53,
            column: 19
          }
        }, {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 66,
            column: 5
          }
        }],
        line: 53
      },
      "3": {
        loc: {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 73,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 69,
            column: 15
          }
        }, {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 73,
            column: 5
          }
        }],
        line: 69
      },
      "4": {
        loc: {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 88,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 85,
            column: 15
          }
        }, {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 88,
            column: 5
          }
        }],
        line: 85
      },
      "5": {
        loc: {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 91,
            column: 18
          }
        }, {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 92,
            column: 17
          }
        }, {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        }],
        line: 91
      },
      "6": {
        loc: {
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 108,
            column: 14
          }
        }, {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        }],
        line: 108
      },
      "7": {
        loc: {
          start: {
            line: 121,
            column: 4
          },
          end: {
            line: 125,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 121,
            column: 4
          },
          end: {
            line: 121,
            column: 18
          }
        }, {
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 125,
            column: 5
          }
        }],
        line: 121
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "02c2e31ad4cbaf914c1a801e9b5d6008eab6f59c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_3e0awlrzq = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_3e0awlrzq();
var _ref = (cov_3e0awlrzq().s[0]++, _stylingConstants.default),
  border = _ref.border,
  color = _ref.color,
  font = _ref.font;
var buttonEvolutionStyles = (cov_3e0awlrzq().s[1]++, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  appearance: none;\n  position: relative;\n  box-sizing: border-box;\n  height: var(--inputButtonHeight, 40px);\n  ", ";\n  max-width: 100%;\n  padding: 0 ", "px;\n  -webkit-font-smoothing: antialiased;\n  -webkit-touch-callout: none;\n  text-rendering: optimizeLegibility;\n  cursor: pointer;\n  user-select: none;\n  text-align: center;\n  vertical-align: middle;\n  text-decoration: none;\n  text-transform: none;\n  outline: 0;\n  color: ", ";\n  background-color: ", ";\n  margin: 0;\n  border: ", ";\n  border-radius: var(--generalBorderRadius, 12px);\n\n  font-size: ", ";\n\n  will-change: border-color, background;\n  transition: border-color linear 50ms, background linear 50ms;\n\n  ", ";\n\n  ", ";\n\n  & > svg {\n    vertical-align: middle;\n  }\n\n  &::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (props) {
  cov_3e0awlrzq().f[0]++;
  cov_3e0awlrzq().s[2]++;
  return (cov_3e0awlrzq().b[0][0]++, props.lines === 1) && (cov_3e0awlrzq().b[0][1]++, "line-height: calc(3 * ".concat((0, _helpers.getFontSize)(props), " - ").concat(border.widthBase, " * 2);"));
}, (0, _lodash.get)(_themeMapper.evolutionTheme, 'spacings.lg', 16), _helpers.getTextColor, function (props) {
  cov_3e0awlrzq().f[1]++;
  cov_3e0awlrzq().s[3]++;
  return props.outline ? (cov_3e0awlrzq().b[1][0]++, 'transparent') : (cov_3e0awlrzq().b[1][1]++, (0, _helpers.getBgColor)(props));
}, _helpers.getBorder, _helpers.getFontSize, function (props) {
  cov_3e0awlrzq().f[2]++;
  cov_3e0awlrzq().s[4]++;
  return (cov_3e0awlrzq().b[2][0]++, !props.disabled) && (cov_3e0awlrzq().b[2][1]++, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      :hover {\n        ", ";\n      }\n\n      :active {\n        ", ";\n      }\n\n      :focus {\n        ", ";\n      }\n    "])), _constants.EVOLUTION_STATE_STYLES[props.variant].hover, _constants.EVOLUTION_STATE_STYLES[props.variant].active, _constants.EVOLUTION_STATE_STYLES[props.variant].focus));
}, function (props) {
  cov_3e0awlrzq().f[3]++;
  cov_3e0awlrzq().s[5]++;
  return (cov_3e0awlrzq().b[3][0]++, props.width) && (cov_3e0awlrzq().b[3][1]++, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      width: ", ";\n      overflow: hidden;\n    "])), props.width));
}, function (props) {
  cov_3e0awlrzq().f[4]++;
  cov_3e0awlrzq().s[6]++;
  return (cov_3e0awlrzq().b[4][0]++, props.large) && (cov_3e0awlrzq().b[4][1]++, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      font-size: ", ";\n    "])), font.sizeL));
}, function (props) {
  cov_3e0awlrzq().f[5]++;
  cov_3e0awlrzq().s[7]++;
  return (cov_3e0awlrzq().b[5][0]++, props.disabled) && (cov_3e0awlrzq().b[5][1]++, props.neutral) && (cov_3e0awlrzq().b[5][2]++, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n      color: var(--disableTextColor, #b2aebf);\n      background-color: var(--disableColor, #f6f6f8);\n\n      &:hover,\n      &:focus {\n        color: ", ";\n        background-color: ", ";\n      }\n      &:active {\n        background-color: ", ";\n      }\n    "])), (0, _polished.lighten)(0.1, color.disabledText), (0, _polished.lighten)(0.1, color.disabledBackground), (0, _polished.darken)(0.1, color.disabledBackground)));
}, function (props) {
  cov_3e0awlrzq().f[6]++;
  cov_3e0awlrzq().s[8]++;
  return (cov_3e0awlrzq().b[6][0]++, props.flat) && (cov_3e0awlrzq().b[6][1]++, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n      background: none;\n      color: ", ";\n\n      &:not(:disabled):hover,\n      &:not(:disabled):focus {\n        background: none;\n        color: ", ";\n      }\n    "])), _helpers.getTextColor, _helpers.getTextColor));
}, function (props) {
  cov_3e0awlrzq().f[7]++;
  cov_3e0awlrzq().s[9]++;
  return (cov_3e0awlrzq().b[7][0]++, props.disabled) && (cov_3e0awlrzq().b[7][1]++, (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n      ", ";\n      cursor: not-allowed;\n    "])), _helpers.disabled));
}));
var _default = exports.default = buttonEvolutionStyles;